import { render } from "./ClickedOutside.vue?vue&type=template&id=3058a292&ts=true"
import script from "./ClickedOutside.vue?vue&type=script&lang=ts"
export * from "./ClickedOutside.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/prod_sara2/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__